/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { getCountryFlag } from 'utils/fetchassets';
import * as S from './resultsCard.styled';
import Typography from '@mui/material/Typography';
import {
    getColor,
    makeScore,
} from '../../BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/Results/Results';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

type Stream = {
    title: string;
    score: number;
    type: string;
    max_score: number;
    passed: boolean;
};

type CountryData = {
    name: string;
    flag: string;
    streams: Stream[];
};

const StreamItem = ({ title, score, type, max_score, passed }: Stream) => {
    const badgeColor = getColor(score, max_score, passed);
    return (
        <S.SideBarCollectionItem>
            {' '}
            <S.CollectionItemHeader>{type}</S.CollectionItemHeader>
            <S.CollectionItemBody>
                <S.CollectionItemText>{title}</S.CollectionItemText>

                <S.CollectionItemBadge style={{ background: badgeColor }}>
                    {makeScore(score, max_score, passed)}%
                </S.CollectionItemBadge>
            </S.CollectionItemBody>
        </S.SideBarCollectionItem>
    );
};

export const CountryCard = ({ name, flag, streams }: CountryData) => (
    <S.CountryCardWrapper>
        <S.CountryHeader>
            <Typography>
                <S.SideBarCollectionHeader>
                    <img
                        style={{ width: '40px', height: '30px' }}
                        src={
                            window.location.protocol +
                            '//' +
                            window.location.host +
                            getCountryFlag(name)
                        }
                        alt={name}
                    />
                    <div>{name}</div>
                </S.SideBarCollectionHeader>
            </Typography>
        </S.CountryHeader>
        {streams.map((stream, idx) => (
            <StreamItem
                key={idx}
                title={stream.title}
                score={stream.score}
                type={stream.type}
                max_score={stream.max_score}
                passed={stream.passed}
            />
        ))}
    </S.CountryCardWrapper>
);

const AssessmentResults = ({ data }: any) => {
    const { t } = useTranslation();
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    return (
        <S.Wrapper>
            <S.Title>{t('eligibilityAssessment', { lng: language })}</S.Title>
            {data.map((country: any, idx: number) => (
                <CountryCard key={idx} {...country} />
            ))}
        </S.Wrapper>
    );
};

export default AssessmentResults;
